"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Empty module for conditional compilation. */
// tslint:disable-next-line:no-default-export
exports.default = undefined;
